import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./contexts/AuthContext";
import { BrowserRouter } from "react-router-dom";
import {
  QueryParamProvider,
  transformSearchStringJsonSafe,
} from "use-query-params";
import "react-fine-uploader/gallery/gallery.css";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";
import "./i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const queryStringifyOptions = {
  transformSearchString: transformSearchStringJsonSafe,
};

root.render(
  <Suspense fallback={<div></div>}>
    <BrowserRouter>
      <AuthProvider>
        <QueryParamProvider adapter={ReactRouter6Adapter}>
          <App />
        </QueryParamProvider>
      </AuthProvider>
    </BrowserRouter>
  </Suspense>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
